export default __webpack_public_path__ + "static/AcademyGraphic-4e24f92b13b0e6716a115be193d7a296.jpg";